import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  CircularProgress,
  TextField,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import firebase, {
  functionBaseUrl,
  axiosWithToken,
} from "../../common/firebase";
import { listOfSubscriptions } from "../../common/envConfig";
/*import {
  defaultHeightToDefaultHipWidth,
  femaleHeightToDefaultHipWidth,
  maleHeightToDefaultHipWidth,
} from "./misc/hipWidthTable";*/

const template =
  "data:@file/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,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" +
  "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";

function ImportStudentsEnterpriseComponent({ open, close, uid, name, admin, userEmail }) {
  const [isLoading, setIsLoading] = useState(false);
  const [students, setStudents] = useState([]);
  const [email, setEmail] = useState(userEmail);
  let count = 0;
  let error = [];

  const handleCoachEmail = (event) => {
    setEmail(event.target.value);
  };

  const handleFile = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);
        if (data.length === 0) {
          Swal.fire({
            title:
              '<p style="font-size:70%;">No record found, please try again!</p>',
            icon: "error",
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: "Ok",
            customClass: {
              container: "my-swal",
            },
          });
        }
        if (data.length > 0) {
          if (
            "Email" in data[0] === false ||
            "First Name" in data[0] === false ||
            "Last Name" in data[0] === false
          ) {
            Swal.fire({
              title:
                '<p style="font-size:70%;">Please use the correct template and try again!</p>',
              icon: "error",
              showConfirmButton: true,
              showCancelButton: false,
              confirmButtonText: "Ok",
              customClass: {
                container: "my-swal",
              },
            });
          }
        }
        setStudents(data);
      };
      reader.readAsBinaryString(file);
    }
  };

  /*function getHipWidth(gender, height) {
    switch (gender.toUpperCase()) {
      case "MALE":
        return maleHeightToDefaultHipWidth[
          height
        ]
      case "FEMALE":
        return femaleHeightToDefaultHipWidth[
          height
        ]
      case "PREFER NOT TO ANSWER":
        return defaultHeightToDefaultHipWidth[
          height
        ]
      default:
        break;
    }
  }

  function dobFormat(dob) {
    let [month, day, year] = dob.split('-');
    return (month + "/" + day + "/" + year)
  }*/

  const handleImport = async () => {
    setIsLoading(true);
    // Check if coach account exists
    if (admin) {
      const coachDoc = await firebase
        .firestore()
        .collection("users")
        .where("email", "==", email.toLowerCase().replace(/ /g, ""))
        .get();
      if (coachDoc.size === 0) {
        Swal.fire({
          title: `<p style="font-size:70%;">No coach account found with email: ${email}</p>`,
          showConfirmButton: false,
          icon: "warning",
          customClass: {
            container: "my-swal",
          },
          showCloseButton: true,
          allowOutsideClick: true,
        });
        setIsLoading(false);
        return false;
      } else {
        coachDoc.forEach((doc) => {
          uid = doc.id;
          name = doc.data().firstName + " " + doc.data().lastName;
        });
      }
    }

    for (const student of students) {
      try {
        if (student["First Name"] && student["Last Name"] && student["Email"]) {
          const output = {
            email: student["Email"].toLowerCase().replace(/ /g, ""),
            firstName: student["First Name"],
            lastName: student["Last Name"],
            dob: "",
            gender: student["Gender"] ? student["Gender"] : "Male",
            height: student["Height"] ? student["Height"] : "",
            coachId: uid,
            coachName: name,
            dominantHand: student["Dominant Hand"] ? student["Dominant Hand"] : "Right",
            hipWidth: "7.2",
            subPlan: listOfSubscriptions.STUDENT_FREE,
            subPeriod: 0,
            autoRenewal: false,
          };

          await axiosWithToken(functionBaseUrl + "/api/v3/createStudent", {
            method: "post",
            data: output,
          })
            .then((response) => {
              count++;
            })
            .catch((err) => {
              error.push(output.email);
              console.log(err);
            });
        }
      } catch (e) {
        error.push(student["Email"]);
        console.error(e);
      }
    }
    setIsLoading(false);
    close();
    if (count === 0) {
      await Swal.fire({
        title: `<p style="font-size:70%;">No records imported</p>`,
        icon: "error",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
      });
    } else {
      await Swal.fire({
        title: `<p style="font-size:70%;">${count} accounts created successfully!</p>`,
        icon: "success",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
      }).then(() => {
        window.location.reload();
      });
    }
    console.log(error);
  };

  return (
    <>
      <Dialog
        fullWidth
        open={open}
        onClose={close}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id={"form-dialog-title"}>
          <div>
            Import Student Accounts
            <CloseIcon
              style={{
                float: "right",
                marginTop: "-10px",
                marginRight: "-15px",
              }}
              onClick={close}
            />
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            {admin && (
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  margin="dense"
                  label="Coach Email"
                  onChange={handleCoachEmail}
                  defaultValue={email}
                  variant="outlined"
                  inputProps={{ maxLength: 50 }}
                />
              </Grid>
            )}
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div style={{ fontSize: "135%" }}>
                  Select .xlsx file with the same columns as{" "}
                  <a download="Import student accounts.xlsx" href={template}>
                    template
                  </a>
                </div>
                <br />
                <input
                  type="file"
                  id="fileElem"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  onChange={handleFile}
                />
              </Grid>
              <Grid item xs={12} style={{ textAlign: "center" }}>
                <strong>
                  {students?.length > 0 && (
                    <div>{students.length} records found</div>
                  )}
                </strong>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {isLoading && (
            <div>
              <CircularProgress />
              {/*<p><b>Accounts Imported: </b>{count}</p>
            <p><b>Accounts Failed to Import: </b>{error.length}</p>*/}
            </div>
          )}
          <Button onClick={close} color="primary" disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleImport}
            disabled={students.length === 0 || isLoading}
          >
            Import
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export const ImportStudentsEnterprise = ImportStudentsEnterpriseComponent;
